import { type UpgradeRequiredError } from "utilities/apiHandler";

import { BTCol } from "commonComponents/btWrappers/BTCol/BTCol";
import { BTListLayout, ListSection } from "commonComponents/btWrappers/BTListLayout/BTListLayout";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";
import { PackageUpsell } from "commonComponents/entity/marketing/PackageUpsell/PackageUpsell";
import { type IPackageUpsellProps } from "commonComponents/entity/marketing/PackageUpsell/PackageUpsell.types";
import "commonComponents/entity/marketing/PackageUpsellList/PackageUpsellList.less";
import { BTLoading } from "commonComponents/utilities/BTLoading/BTLoading";

import { RouteSubscriptionManager } from "entity/SubscriptionManager/SubscriptionManagerRoute";

export interface IHasUpsellState {
    upgradeRequiredError?: UpgradeRequiredError;

    /**
     * State used when the upsell state is retrying an API call to see if the builder upgraded.
     * If the list already has a piece of loading state, prefer to use that.
     */
    isUpsellRetrying?: boolean;
}

export interface IPackageUpsellListProps extends Omit<IPackageUpsellProps, "title"> {
    listTitle: string;
    upsellTitle: string;
    isLoading?: boolean;
    upgradeBeforeClose: () => void;
}

export const PackageUpsellList: React.FC<IPackageUpsellListProps> = ({
    listTitle,
    upsellTitle,
    isLoading,
    upgradeBeforeClose,
    ...packageUpsellProps
}) => {
    return (
        <BTListLayout className="PackageUpsellList" title={listTitle}>
            <ListSection>
                <BTRow className="PackageUpsellListRow" justify="center" align="middle">
                    <BTCol xs={20} sm={16} md={16}>
                        <PackageUpsell
                            contentClassName="PackageUpsellListContent"
                            title={upsellTitle}
                            {...packageUpsellProps}
                        />
                    </BTCol>
                </BTRow>
            </ListSection>
            <RouteSubscriptionManager
                modalConfig={{ parentRoute: "", beforeClose: upgradeBeforeClose }}
                fromUpgrade={true}
            />
            {isLoading && <BTLoading />}
        </BTListLayout>
    );
};
